<template>
  <div class="intro" :class="{ [`intro--${block.data?.layout}`]: block.data?.layout }">
    <div class="intro__label" v-if="block.data?.label" v-html="block.data?.label" />
    <h1 class="intro__heading" v-if="block.data?.title" v-html="block.data?.title" />
    <div class="intro__meta" v-if="post?.type === 'post'">
      <AtomIcon name="calendar" class="-mt-px" /> {{ toDayjs(post.modifiedDate).format('D MMMM YYYY') }}
    </div>
    <p class="intro__leading" v-if="block.data?.excerpt" v-html="block.data?.excerpt" />
    <div class="intro__figure" v-if="block.data?.image">
      <div class="intro__image">
        <AtomImage :src="block.data?.image.url" :alt="block.data?.image.alt || block.data?.title" v-if="block.data?.image" />
      </div>
      <div class="intro__caption" v-if="block.data?.caption" v-html="block.data?.caption" />
    </div>
  </div>
</template>

<script setup>
const route = useRoute()

const props = defineProps({
  block: Object
})

// Grep post from nuxt data
const { data: post } = useNuxtData(`post-${route.path}`)
</script>

<style lang="scss" scoped>
.intro {
  @apply max-w-3xl;
  @apply grid gap-2 md:gap-4;
  
  &__label {
    @apply font-bold uppercase tracking-[0.25em];
  }

  &__heading {
    @apply font-heading font-bold;
    @apply text-4xl sm:text-5xl md:text-6xl;
  }

  &__leading {
    @apply font-bold text-lg leading-6 md:text-xl md:leading-7;
    // @apply font-bold text-lg leading-6; // Smaller leading
  }

  &__meta {
    @apply text-sm text-[#888] flex items-center gap-2;
  }

  &__figure {
    @apply mt-2 mb-4;
    @apply -mx-[4vw] md:mx-0 max-w-3xl;
  }

  &__image {
    @apply md:rounded md:overflow-hidden;
  }

  &__caption {
    @apply pt-2 text-sm opacity-60;
  }
}
</style>